import React, { Component } from 'react';
import axios from 'axios'; 
import Serverurl from './Apiurl';
import { FormControl, Select, Button, Collapse, Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';


export default class TeacherComparisionreport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teacherarr: [],
      Classarr: [],
      classid: 0,
      ur_id: 0,branchid:'',Branchdata:[],
      comparisionData: {},
      errormessage: '',
      erropen: false,
      errortype: 'error',
    };
  }

  componentDidMount() {
    document.title = "MM Coching Center - Bulk Attendance";
    this.TeacherBind();
	
 if(localStorage.getItem("MMCrole")==="1"){
this.BranchBind();

	 }
  }

  myChangeHandler = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (name === 'ur_id' && value !== "0") {
        this.getClassId();
      }
	   if (name === 'branchid' ) {
		   
		    this.TeacherBind();
		   
	   }
    });
  };
 BranchBind()
{
	axios.get(Serverurl+'ajaxbranch.php?action=getall')
       .then(resp => { 		
			if(resp.data.length>0){
				let strbrid=resp.data[0].br_id
				this.setState({
						Branchdata:resp.data},()=>{
							
						 let branchFromApi = this.state.Branchdata.map(row => {
                          
          return {value: row.br_id, display:row.br_title}
        });	
		 this.setState({branchid:strbrid,
          Branchdata: [{value: '0', display: 'Select Branch'}].concat(branchFromApi)
        });
							
						}) 
			
	 }
	 
	 
	   }) 

}
  TeacherBind() {
    let strbranch=localStorage.getItem("MMCbranchid");
		if(localStorage.getItem("MMCrole")==="1")
		{
			strbranch=this.state.branchid;
		}

	 axios.get(Serverurl+'ajaxteachersubject.php?action=teacherbind&ur_br_id='+strbranch+'&ur_role=3')
	 
	 
      .then(resp => {
        const teacherOptions = resp.data.map(row => ({
          value: row.ur_id,
          display: row.ur_username,
        }));
        this.setState({
          teacherarr: [{ value: '0', display: 'Select Teacher' }, ...teacherOptions],
        });
      });
  }

  getClassId() {
	
	  axios.get(Serverurl+'ajaxteachersubject.php?action=getclassid&ts_ur_id='+this.state.ur_id)
	
      .then(resp => {
        const classIds = resp.data.map(item => item.tc_id).join(',');
        this.setState({ classIdString: classIds }, () => {
          if (classIds) {
            this.ClassBind(classIds);
          } else {
            this.setState({ Classarr: [] });
          }
        });
      });
  }


  ClassBind(tcid) {
    
	axios.get(Serverurl+'ajaxteachersubject.php?action=getclass&tc_id='+tcid)
	
      .then(resp => {
        const classOptions = resp.data.map(row => ({
          value: row.tc_id,
          display: row.tc_title,
        }));
        this.setState({
          Classarr: [{ value: '0', display: 'Select Class' }, ...classOptions],
        });
      });
  }

getRandomColor = () => {
  const r = Math.floor(Math.random() * 255);
  const g = Math.floor(Math.random() * 255);
  const b = Math.floor(Math.random() * 255);
  return `rgba(${r}, ${g}, ${b}, 0.6)`;

};


GetTeacherClassWiseComparisionReport = () => {
  const { ur_id, classid } = this.state;

  axios
    .get(Serverurl+'ajaxteachersubject.php?action=teachercomparisionreportgetall&te_yearid='+localStorage.getItem("MMCyearid")+'&teacherid='+ur_id+'&classid='+classid)
    .then(resp => {
      const subjectColorMap = {}; 
      const labels = [];
      const totalMarks = [];
      const backgroundColors = [];

      resp.data.forEach(item => {
        const label = `${item.te_testname} - ${item.sb_title}`;
        labels.push(label);
        totalMarks.push(item.average_percentage) ;

       
        if (!subjectColorMap[item.sb_title]) {
          subjectColorMap[item.sb_title] = this.getRandomColor();
        }
        backgroundColors.push(subjectColorMap[item.sb_title]);
      });

      const chartData = {
        labels,
        datasets: [
          {
            label: 'Percentage %',
            data: totalMarks,
            backgroundColor: backgroundColors,
         
          },
        ],
      };

      this.setState({ comparisionData: chartData, erropen: false },()=>{
		 
	  });
    });
}; 


  handleClickSearch = () => {
	  
	  if(this.state.ur_id===0){
		  this.setState({erropen:true,errormessage:'please Select Teacher'});
		  return false;
		  
	  }  if(this.state.classid===0){
		  this.setState({erropen:true,errormessage:'please Select Class'});
		  return false;
		  
	  }
    this.GetTeacherClassWiseComparisionReport();
	
 };



handleErrorclose = () => {
   
   this.setState({ erropen: false });
 

 };

  render() {

 

    const options = {
		
		 tooltips: {
    mode: 'label'
  }, 
      responsive: true,
      legend: {
        display: true,
		 position:'bottom'
      },
	  title:{
                    display:true,
                    text:'Performance',
                    fontSize:20
                    },
      type: "bar",
	  scales: {
		  
      yAxes: [{
		 
         ticks: {
            beginAtZero: true,
			max: 100,
                min: 0
         }
      }]
   }
   
    };
	

    return (
      <React.Fragment>
        <div className="containermain">
          <div className="boxheading">
            <div className="contntpad">
              <h2>Teacher Comparison Report</h2>
            </div>
          </div>

          <div className="searchmaster">
            <Collapse in={this.state.erropen}>
              <Alert
                severity={this.state.errortype}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={this.handleErrorclose}
                  >                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {this.state.errormessage}
              </Alert>
            </Collapse>

            <ul>
			{localStorage.getItem("MMCrole")==="1" &&(
<li>
<p>Branch</p><p> <FormControl  className="stadrp">
          <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		 
          onChange={this.myChangeHandler}
          id="branchid"
		   value={this.state.branchid}
		  name="branchid"
		
		
        >
		{this.state.Branchdata.map(brrows => (
            <option  
            
              value={brrows.value}
            >
              {brrows.display}
            </option  >
          ))}
		
        </Select>
       </FormControl>
		
			</p>
</li>)}
              <li>
                <p><span className="validation">*</span>Teacher</p>
                <FormControl fullWidth size="small">
                  <Select native value={this.state.ur_id} onChange={this.myChangeHandler} name="ur_id">
                    {this.state.teacherarr.map(row => (
                      <option key={row.value} value={row.value}>{row.display}</option>
                    ))}
                  </Select>
                </FormControl>
              </li>

              <li>
                <p><span className="validation">*</span>Class</p>
                <FormControl fullWidth size="small">
                  <Select native value={this.state.classid} onChange={this.myChangeHandler} name="classid">
                    {this.state.Classarr.map(row => (
                      <option key={row.value} value={row.value}>{row.display}</option>
                    ))}
                  </Select>
                </FormControl>
              </li>

              <li>
                <p className="searchbutton"><br/>
                  <Button variant="contained" onClick={this.handleClickSearch} endIcon={<SearchIcon />}>
                    Search
                  </Button>
                </p>
              </li>
            </ul>
          </div>

		  

   {this.state.comparisionData.labels && this.state.comparisionData.labels.length > 0 && this.state.comparisionData.datasets && this.state.comparisionData.datasets[0].data && this.state.comparisionData.datasets[0].data.length > 0 ? (
		 
		 
		
		
		<Bar 
	  
	  
	  
        data={this.state.comparisionData}
        width={null}
        height={null}
       options={options}
      />
	  
	  
		
		
		):(
		<p className="aligncenter">No Record Found</p>
		)
		}

        </div>
      </React.Fragment>
    );
  }
}
